import SesamyNivoTheme from "@/components/Nivo/SesamyNivoTheme";
import Tooltip from "@/components/Nivo/Tooltip";
import dynamic from "next/dynamic";
import { useEffect } from "react";

const ResponsiveCalendar = dynamic(
  () =>
    import("@nivo/calendar").then(
      ({ ResponsiveTimeRange }) => ResponsiveTimeRange,
    ),
  { ssr: false },
);

const getFirstDayOfMonth = (date: Date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  return new Date(year, month, 1);
};

const getLastDayOfMonth = (date: Date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  return new Date(year, month, 0);
};

const oneYearAgoFromDate = (date: Date) => {
  date.setUTCFullYear(date.getFullYear() - 1);
  return date;
};

const getMondayOfWeek = (date: Date) => {
  date.setDate(date.getDate() + ((7 - date.getDay()) % 7));
  return date;
};

const Heatmap = ({
  data,
  fullyRendered = () => {},
}: {
  data: any;
  fullyRendered?: Function;
}) => {
  const from = getMondayOfWeek(
    getFirstDayOfMonth(oneYearAgoFromDate(new Date())),
  );
  const to = getMondayOfWeek(getLastDayOfMonth(new Date()));

  useEffect(() => {
    if (typeof fullyRendered === "function") {
      fullyRendered(true);
    }
  }, [fullyRendered]);

  return (
    <div className="relative w-full pb-[14.5%]">
      <div className="absolute inset-0">
        <ResponsiveCalendar
          data={data}
          theme={{
            ...SesamyNivoTheme,
            labels: {
              text: {
                fontSize: 12,
                fill: "var(--muted-foreground)",
              },
            },
          }}
          emptyColor="var(--background)"
          colors={
            [
              ...Object.values([
                "#eeecfd",
                "#bfb9e2",
                "#cac1f9",
                "#b1a5f9",
                "#8C78FB",
                "#9B8BF9",
                "#7D68F4", // same as primary
                "#433881",
                "#252048",
              ])
                .reverse()
                .slice(0, 4),
            ] as string[]
          }
          margin={{ top: 20, right: 0, bottom: 0, left: 0 }}
          dayBorderWidth={0}
          weekdayTicks={[0, 2, 4, 6]}
          firstWeekday="monday"
          from={from}
          to={to}
          dayRadius={2}
          daySpacing={2}
          tooltip={({ day, value }) => (
            <Tooltip className="row-left gap-2">
              <span className="text-muted-foreground">{day}</span> {value}
            </Tooltip>
          )}
        />
      </div>
    </div>
  );
};

export default Heatmap;
